<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import Monitor from "@/services/Monitor";
    import modalManageModuleAccess from "@/components/modals/monitor/modalManageModuleAccess";

    export default {
        components: { Layout, PageHeader, modalManageModuleAccess },
        data() {
            return {
                showLoader: false,
                error: null,
                tableData: [],
                items: [] ,
                title: "Dashboard Access",
                currentPage: 1,
                perPage: 15,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "object",
                isUpdating: false,
                sortDesc: true,
                isTableLoading: false,
                roles : [],
                fields: [
                    {
                        key: "role",
                        label: "Role",
                        visible: false,
                    },
                    {
                        key: "object_id",
                        label: "Object ID",
                        visible: true,
                    },
                    {
                        key: "object",
                        label: "Object",
                        visible: true,
                    },
                    {
                        key: "module_name",
                        label: "Module Name",
                        visible: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        visible: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        visible: true,
                        slot: 'status'
                    },

                ],
                filterInput: {
                    role: '',
                },
                totalRows: 0,
                showModal: false,
                selectedRow: null,
                statusOptions: [
                    { value: 0, text: "0" },
                    { value: 1, text: "1" }
                ],
                module_names: [],
                module_name: null,
                roleId: null,
                roleName: null,
            };
        },
        async mounted() {
            try {
                await this.getRbacObjectRoleAccess();
                await this.getRbacRoles();
            } catch (error) {
                console.error('Error during component initialization:', error);
            }
        },
        methods: {
   
            async getRbacRoles(){
                try {
                    const response = await Monitor.getRbacRoles();
                    this.roles = response.data.data ;
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                }
            },

            async getRbacObjectRoleAccess(roleId) {
                this.showLoader = true;
                try {
                    this.isTableLoading = true;
                    const response = await Monitor.getRbacObjectRoleAccess(roleId);
                    this.allData = response.data.data;
                    this.tableData = this.allData;
                    this.module_names = [
                        ...new Set(
                            this.tableData.map(item => {
                                let name = item.module_name;
                                return (name === null || name.trim() === '') ? null : name;
                            })
                        )
                    ].sort((a, b) => {
                        if (a === null && b !== null) return -1;   // null (or empty) first
                        if (a !== null && b === null) return 1;
                        if (a === null && b === null) return 0;
                        return a.localeCompare(b); // alphabetical
                    });

                    this.applyFilters();

                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = [];
                    this.totalRows = 0;
                } finally {
                    this.showLoader = false;
                    this.isTableLoading = false;
                }
            },

            applyFilters() {
                let filtered = this.allData;

                // filter by role
                if (this.roleId) {
                    filtered = filtered.filter(item => item.role_id === this.roleId);
                }

                // filter by module
                if (this.module_name) {
                    filtered = filtered.filter(item => item.module_name === this.module_name);
                }

                this.tableData = filtered;
                this.totalRows = filtered.length;
            },

            async handleStatusChange(item) {
                try {
                    const dataToUpdate = {
                        ...item,
                        status: item.status ? 1 : 0,
                    };
                    const response = await Monitor.updateRbacObjectRoleAccess(dataToUpdate);
                    if (!response.data) {
                        const error = response.data.error ? response.data.error : 'Failed';
                        this.failedmsg(error);
                    }
                } catch (error) {
                    this.failedmsg(error.message);
                } finally {
                    this.showLoader = false;
                }
            },

            handleRoleChange(roleId) {
                this.roleId = roleId || null; // normalize empty/'' to null

                // find role name
                this.roleName = null;
                if (this.roleId) {
                    const role = this.roles.find(r => r.id === this.roleId);
                    this.roleName = role ? role.name : null;
                }

                if (!this.roleId) {
                    // No role selected → filter only by module
                    if (this.module_name === null) {
                        this.tableData = this.allData; // all rows
                    } else {
                        this.tableData = this.allData.filter(item => item.module_name === this.module_name);
                    }
                } else {
                    // Role selected → filter by role + module
                    if (this.module_name === null) {
                        this.tableData = this.allData.filter(item => item.role_id === this.roleId);
                    } else {
                        this.tableData = this.allData.filter(item =>
                            item.role_id === this.roleId && item.module_name === this.module_name
                        );
                    }
                }

                this.totalRows = this.tableData.length;
            },

            handleModuleChange(selectedModule) {
                if (!this.roleId) {
                    // ✅ No role selected
                    if (selectedModule === null) {
                        // show all data (no filters)
                        this.tableData = this.allData;
                    } else {
                        // filter only by module
                        this.tableData = this.allData.filter(item => item.module_name === selectedModule);
                    }
                } else {
                    if (selectedModule === null) {
                        // filter only by role
                        this.tableData = this.allData.filter(item => item.role_id === this.roleId);
                    } else {
                        // filter by both role + module
                        this.tableData = this.allData.filter(item =>
                            item.role_id === this.roleId && item.module_name === selectedModule
                        );
                    }
                }

                this.totalRows = this.tableData.length;
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            modalManageGroupAccess(){
                this.$bvModal.show("manage_module_access");
            }
        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-6  col-md-4 mx-auto">
                                <b-form-group label="Filter by Role" label-for="role" class="mb-3 text-center">
                                    <select v-model="filterInput.role" class="form-select" id="role" @change="handleRoleChange(filterInput.role)">
                                        <option value="">Show All</option>
                                        <option v-for="role in roles" :key="role.id" :value="role.id">{{role.name}}</option>
                                    </select>
                                </b-form-group>
                            </div>
                            <div class="col-6  col-md-4 mx-auto">
                                <b-form-group label="Filter by Module" label-for="role" class="mb-3 text-center">
                                    <select v-model="module_name" class="form-select" id="module_names" @change="handleModuleChange(module_name)">
                                        <option
                                                v-for="module in module_names"
                                                :key="module === null ? 'null' : module"
                                                :value="module"
                                        >
                                            {{ module === null ? 'Show All' : module }}
                                        </option>
                                    </select>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!showLoader">
            <div class="col-12">
                <div class="card">

                    <div class="card-body">

                        <div class="row">
                            <div class="col-sm-6 col-md-6 mb-3">
                                <b-button variant="primary"
                                          v-if="module_name != null"
                                          :disabled="roleId == null"
                                          @click="modalManageGroupAccess"
                                >Bulk Manage {{module_name}} Module Access
                                </b-button>
                            </div>

                            <!-- Search -->
                            <div class="col-sm-6 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>

                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isTableLoading"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >
                                <template #cell(status)="row">
                                    <div class="form-check form-switch form-switch-lg" dir="ltr">
                                        <input
                                                type="checkbox"
                                                class="form-check-input"
                                                :id="'customSwitchsizelg' + row.item.object_id"
                                                v-model="row.item.status"
                                                @change="handleStatusChange(row.item)"
                                        />
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="card-body d-flex align-items-center justify-content-center">
                <b-spinner large></b-spinner>
            </div>
        </div>

        <modalManageModuleAccess
                :roleId="roleId"
                :role="roleName"
                :module="module_name"
                @onRefresh="getRbacObjectRoleAccess"
        ></modalManageModuleAccess>

   </Layout>
</template>
